import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Badge
} from 'reactstrap';
import { required } from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import axiosInstance from '@src/axios-instance';
import Select from 'react-select';

const fieldValidator = {
  association_id: [required]
};

class AssignAssociationModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};
    fields['association_id'] = {
      value:
        props.entity.association_id !== null
          ? {
              label: props.entity.association_name,
              value: props.entity.association_id
            }
          : null,
      visited: false,
      error: false
    };

    this.state = {
      ...fields,
      associatons: [],
      similar: [],
      commonAreaOnly: false,
      loaded: false
    };

    this.loadOptions();
  }

  loadOptions = () => {
    axiosInstance()
      .get(`/associations/full-list/${this.props.entity.id}.json`)
      .then(response => {
        const newState = {
          loaded: true,
          associations: response.data.associations,
          similar: response.data.similar,
          commonAreaOnly: response.data.commonAreaOnly
        };
        this.setState(newState);
      })
      .catch(err => {
        console.log(err);
      });
  };

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event === null
          ? ''
          : event,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    const updateState = {
      [name]: inputData
    };

    this.setState(updateState, this.checkCommonAreaOnly);
  };

  checkCommonAreaOnly = () => {
    axiosInstance()
      .get(
        `/associations/check-common-area/${this.state.association_id.value.value}.json`
      )
      .then(response => {
        const newState = {
          commonAreaOnly: response.data.commonAreaOnly
        };
        this.setState(newState);
      })
      .catch(err => {
        console.log(err);
      });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] =
        formData[key].value.value !== undefined
          ? formData[key].value.value
          : formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      this.props.saveEntity(postData, this.props.toggle);
    }
    return false;
  };

  render = () => {
    const addressArr = [];
    const cognitoForm = this.props.entity.evidence_of_insurance_form;
    if (cognitoForm !== null) {
      addressArr.push(cognitoForm.property_address_line_1);
      addressArr.push(cognitoForm.property_address_line_2);
      addressArr.push(cognitoForm.property_address_city);
      addressArr.push(cognitoForm.property_address_state);
      addressArr.push(cognitoForm.property_address_postal_code);
    }

    const address = addressArr.filter(n => n).join(', ');

    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {'Assign an Association'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            {this.state.loaded && (
              <ModalBody className={'p-4'}>
                <div className={'pb-3'}>
                  <span className={'font-weight-bold color-blue'}>
                    Submitted Association Name
                  </span>
                  <div>{this.props.entity.association_name}</div>
                </div>
                <div className={'pb-3'}>
                  <span className={'font-weight-bold color-blue'}>
                    Submitted Unit Address
                  </span>
                  <div>{address}</div>
                </div>
                {this.props.entity.association_id === null && (
                  <p>No match found. Please assign an Association below.</p>
                )}
                <Row>
                  <Col xs={12}>
                    <div className={'form-group mb-1'}>
                      <span className={'font-weight-bold'}>
                        Assign an Association*
                      </span>
                      <Select
                        value={this.state.association_id.value}
                        options={this.state.associations}
                        onInputChange={inputValue =>
                          this.setState({ inputValue })
                        }
                        placeholder={
                          this.state.similar.length === 0
                            ? 'No close match found. Type to search more ...'
                            : 'See suggestions below or type to search more ..'
                        }
                        onChange={event =>
                          this.updateForm(event, 'association_id')
                        }
                      />
                    </div>
                    {this.props.entity.unit_id !== null && (
                      <div className={'color-danger'}>
                        Important: There is already a unit assigned to this
                        Evidence of Insurance. If the Association is
                        re-assigned, the unit must be re-assigned too.
                      </div>
                    )}
                    {this.state.commonAreaOnly && (
                      <React.Fragment>
                        <span class={'color-danger'}>
                          Warning: This Association is{' '}
                        </span>
                        <Badge color={'warning'}>
                          Common Area Only - No EOIs.
                        </Badge>
                      </React.Fragment>
                    )}
                  </Col>
                  {this.state.association_id.value === null && (
                    <Col xs={12} className={'pt-4'}>
                      <strong>Suggestions:</strong>
                      <div className={'pl-3'}>
                        {this.state.similar.map(item => {
                          return (
                            <Button
                              color={'link'}
                              size={'sm'}
                              className={'btn-block text-left'}
                              key={'suggestion-' + item.id}
                              onClick={event =>
                                this.updateForm(item, 'association_id')
                              }
                            >
                              {item.label} - {item.address}
                            </Button>
                          );
                        })}
                      </div>
                    </Col>
                  )}
                </Row>
              </ModalBody>
            )}
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Assign
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default AssignAssociationModal;
